import { jsx } from 'react/jsx-runtime';
import { InputGroup } from '../../InputGroup/InputGroup.es.js';
import { CheckboxGroupProvider } from '../Checkbox.Group.Context/provider.es.js';

const CheckboxGroup = ({ children, name, onChange, disabled, value, ...rest })=>{
    return jsx(InputGroup, {
        disabled: disabled,
        ...rest,
        children: jsx(CheckboxGroupProvider, {
            disabled: disabled,
            onChange: onChange,
            value: value,
            children: children
        })
    });
};
CheckboxGroup.displayName = 'Checkbox.Group';

export { CheckboxGroup, CheckboxGroup as default };
//# sourceMappingURL=Checkbox.Group.es.js.map
